import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import DropdownAddModelo from '../../../components/ListaModelos/components/DropdownAddModelo.jsx'; // Suponiendo que haya algo similar a DropdownAddMedio
import Modelo3DCard from './Modelo3DCard.jsx';
// import FiltrosExplorador from './FiltrosExplorador.jsx'; // Reutilizamos el mismo componente de filtros
import "/src/pages/Profile/Profile.css";

const ExploradorModelos3D = ({ onModeloSelect, showFilters = false , item}) => {
    const [modelList, setModelList] = useState([]); // Estado para almacenar los modelos obtenidos
    const [selectedModelId, setSelectedModelId] = useState(null); // Track selected model

    console.log("item", item)
    // Filtro de modelos 3D
    const [filtros, setFiltros] = useState({
        nombre: '',
        tipo: '',
        categoria: '',
        tags: ''
    });

    useEffect(() => {
        // Función para obtener los modelos 3D
        renovarLista();
    }, []); // Se ejecuta solo una vez al montar el componente

    const renovarLista = () => {
        // Construir los parámetros de consulta según los filtros seleccionados
        const queryParams = new URLSearchParams(filtros).toString();

        axios.get(`customized-keyrings/`)
            .then(response => {
                setModelList(response.data); // Almacena los modelos en el estado
                console.log('Exploración de modelos 3D:', response.data);
            })
            .catch(error => {
                // Manejar cualquier error ocurrido durante la solicitud
                console.error('Error fetching modelos 3D:', error);
            });
    };

    useEffect(() => {
        renovarLista();
    }, [filtros]); // Se ejecuta cada vez que cambian los filtros
    const handleModelSelect = (model) => {
        // setSelectedModelId(model.id); // Update selected model ID
        onModeloSelect(model); // Call parent onModeloSelect callback
    };

    return (
        <div className='min-h-full max-h-full flex flex-col'>
            {/* Filtros para la exploración de modelos 3D */}
            {/*{showFilters && <FiltrosExplorador setFiltros={setFiltros} filtros={filtros} />}*/}

            {/* Listado de modelos 3D */}
            <div className="m-2 mt-0 mr-0 pr-3 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 flex-1 overflow-y-auto">
                {modelList.map(model => (
                    <Modelo3DCard
                        key={model.id}  // Usar un identificador único para cada modelo
                        model={model}
                        isSelected={model.id === item.keyring} // Pass selected status
                        onModeloSelect={onModeloSelect}
                    />
                ))}
            </div>
        </div>
    );
};

export default ExploradorModelos3D;
